module.exports = __webpack_public_path__ + "img/Medieval_Sword_Falchion.3d250beb.png";